var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6236,
    cy: 10.5,
    r: 10.5,
    fill: "#24292F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0899 5.25H16.9236L13.3183 8.74591C13.3183 8.74591 12.3023 9.99708 10.6174 9.99708C8.9324 9.99708 7.9165 8.74591 7.9165 8.74591L4.32356 5.25H6.15718L9.18019 8.19393C9.18019 8.19393 9.83683 8.69685 10.6174 8.69685C11.3979 8.69685 12.0545 8.19393 12.0545 8.19393L15.0899 5.25ZM6.15718 15.75H4.32356L7.92887 12.2541C7.92887 12.2541 8.9448 11.0029 10.6297 11.0029C12.3147 11.0029 13.3306 12.2541 13.3306 12.2541L16.9236 15.75H15.0899L12.0669 12.8061C12.0669 12.8061 11.4103 12.3032 10.6297 12.3032C9.84923 12.3032 9.19259 12.8061 9.19259 12.8061L6.15718 15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.2f60424a.svg";
export { ForwardRef as ReactComponent };